import './aggregatorAcceptConsent.scss';

// @vendors
import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';

// @components
import AggregatorAcceptConsentStep from 'components/aggregator/aggregatorAcceptConsent/aggregatorAcceptConsentStep/aggregatorAcceptConsentStep';
import AggregatorAcceptConsentStepOK from 'components/aggregator/aggregatorAcceptConsent/aggregatorAcceptConsentStepOK/aggregatorAcceptConsentStepOK';
import AggregatorAcceptConsentStepKO from 'components/aggregator/aggregatorAcceptConsent/aggregatorAcceptConsentStepKO/aggregatorAcceptConsentStepKO';
import AggregatorInfo from 'components/aggregator/aggregatorInfo/AggregatorInfo';

// @constants
import { STEP, OK, KO } from 'constants/aggregator/consentViewType';

class AggregatorAcceptConsent extends React.Component {


    buildContent = (type) => {
        switch (type) {
            case OK:
                return <AggregatorAcceptConsentStepOK />;
            case KO:
                return <AggregatorAcceptConsentStepKO />;
            default:
                return <AggregatorAcceptConsentStep />;
        }
    }

    render() {
        const { type } = this.props.match.params;

        return (
            <Fragment>
                {this.buildContent(type)}
                {type === STEP &&
                    <div className="aggregator-add-entity__sidebar col-xs-12 col-md-4">
                        <AggregatorInfo />
                    </div>
                }
            </Fragment>
        )
    }
}

AggregatorAcceptConsent.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            type: PropTypes.oneOf([STEP, OK, KO]).isRequired
        }),
    }),
}

export default withRouter(AggregatorAcceptConsent);
